var formLoader = function() {
	jQuery('.wpcf7-submit').click(function() {
		 jQuery('.form-container').addClass('form-container--event-blocked');
	});

	document.addEventListener( 'wpcf7invalid', function( event ) {
	    jQuery('.form-container').removeClass('form-container--event-blocked');
	}, false );


	document.addEventListener( 'wpcf7mailfailed', function( event ) {
	    jQuery('.form-container').removeClass('form-container--event-blocked');
	    jQuery('.form-container').addClass('failed');
	}, false );

	document.addEventListener( 'wpcf7mailsent', function( event ) {
		jQuery('.form-container').removeClass('form-container--event-blocked');
	    jQuery('.form-container').addClass('success');

	}, false );
};

/*
 ######     #######   ##    ##   ########   
##    ##   ##     ##  ###   ##   ##         
##         ##     ##  ####  ##   ##         
##         ##     ##  ## ## ##   ######     
##         ##     ##  ##  ####   ##         
##    ##   ##     ##  ##   ###   ##         
 ######     #######   ##    ##   ##         
*/

/** 
	À décommenter et modifier pour activer un chargement entre les changements de page
	fonctions : showLoader / hideLoader à compléter
	Defaut : false
**/
// pageTransition = true;

/** 
	À décommenter et modifier pour changer le breakpoint activant les animations parallax
	activé par défaut à partir des tablettes (768)
**/
parallaxBreakpoint = 0;

// La barre d'admin WordPress apparait à partir de :
var adminbarBreakpoint = 992;


var showLoader = function(url) {
	tl = new TimelineLite();
	tl.pause();
	tl.add([
		// On peut chainer les évènements TweenMax ici. Example :
		TweenMax.fromTo( jQuery('html'), 0.3, { opacity: 1 }, { opacity: 0 } ),
		TweenMax.fromTo( jQuery('.page-container'), 0.3, { y: 0 }, { y: 50 } )
		// TweenMax.fromTo( $pan2l, 0,   { opacity: 0 }, { opacity: 1, delay: 0.10 } ),
		// TweenMax.fromTo( $pan3l, 0,   { opacity: 0 }, { opacity: 1, delay: 0.20 } ),
		// TweenMax.fromTo( $logo,  0.1, { opacity: 0 }, { opacity: 1, delay: 0.20 } )
	]);
	tl.call(function() {
		// A la fin de l'anim, on redirige vers la nouvelle URLs
		window.location.href = url;
	});
	tl.play();
};

var hideLoader = function() {
	// On lance l'animation de révélation de la page
	tl = new TimelineLite();
	tl.pause();
	tl.call(function() {
		initScrollAnimations();
	});
	tl.add([
		TweenMax.fromTo( jQuery('html'), 0.3, { opacity: 0 }, { opacity: 1 } ),
		TweenMax.fromTo( jQuery('.page-container'), 0.3, { y: 50 }, { y: 0 } )
		// On peut chainer les évènements TweenMax ici. Example :
		// TweenMax.fromTo( $pan1, 0.4, { x: '0' }, { x: '100%', delay: 0 } ),
		// TweenMax.fromTo( $pan2, 0.4, { x: '0' }, { x: '100%', delay: 0.15 } ),
		// TweenMax.fromTo( $logo, 0.2, { opacity: 1 }, { opacity: 0, delay: 0  } )
	]);	
	tl.play();
};

(function($) {
	/*
	########   ########    ######    ####  ########   ########   
	##     ##  ##         ##    ##    ##        ##    ##         
	##     ##  ##         ##          ##       ##     ##         
	########   ######      ######     ##      ##      ######     
	##   ##    ##               ##    ##     ##       ##         
	##    ##   ##         ##    ##    ##    ##        ##         
	##     ##  ########    ######    ####  ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/

	/* Fonctions exécutées à chaque resize */
	var resizeHandler = function() {
		$(window).trigger('scroll');
		initScrollAnimations();
		resizeParallax();
		
		/* Autres fonctions jouées au resize */
		// resizeSlider();
		// resizeNav();
		resize_mcubeSplitText();

	};

	var getMenuHeight = function() {
		$menuHeight = $('.header').innerHeight();
		if ( $('body').hasClass('admin-bar') && $(window).width() >= adminbarBreakpoint ) {
			$menuHeight = $menuHeight + 32;
		}
		return $menuHeight;
	};

		
	
	/*
	 ######     ######    ########    #######   ##         ##         
	##    ##   ##    ##   ##     ##  ##     ##  ##         ##         
	##         ##         ##     ##  ##     ##  ##         ##         
	 ######    ##         ########   ##     ##  ##         ##         
		  ##   ##         ##   ##    ##     ##  ##         ##         
	##    ##   ##    ##   ##    ##   ##     ##  ##         ##         
	 ######     ######    ##     ##   #######   ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/
	/* Fonctions exécutées au scroll */
	var scrollHandler = function() {
		var scrollTop = $(window).scrollTop();
		
		// /* EXEMPLE */
		if (scrollTop > 380) {
			$('body').addClass('page-scrolled');
		}
		else {
			$('body').removeClass('page-scrolled');
		}
	};

	/*
	##          #######      ###     ########   ########   ########   
	##         ##     ##    ## ##    ##     ##  ##         ##     ##  
	##         ##     ##   ##   ##   ##     ##  ##         ##     ##  
	##         ##     ##  ##     ##  ##     ##  ######     ########   
	##         ##     ##  #########  ##     ##  ##         ##   ##    
	##         ##     ##  ##     ##  ##     ##  ##         ##    ##   
	########    #######   ##     ##  ########   ########   ##     ##  
	*/

	
	/*	Ajout d'un loader sur le chargement initial d’une page 
		Uniquement si la fonction de transition de page est active 
	*/
	if ( pageTransition ) {
		$('body').imagesLoaded( { background: true })
		.always( function(instance) {
			hideLoader();
		});
	}

	/*
	 ######    ##         ####  ########   ########   ########    ######    
	##    ##   ##          ##   ##     ##  ##         ##     ##  ##    ##   
	##         ##          ##   ##     ##  ##         ##     ##  ##         
	 ######    ##          ##   ##     ##  ######     ########    ######    
	      ##   ##          ##   ##     ##  ##         ##   ##          ##   
	##    ##   ##          ##   ##     ##  ##         ##    ##   ##    ##   
	 ######    ########   ####  ########   ########   ##     ##   ######    
	*/

	var sliders = (function() {
		var init = function() {
			var slickHeader = $('.slider-header .slider__container');

			if (slickHeader.length > 0) {
				slickHeader.slick({
					autoplay: true,
					autoplaySpeed: 5000,
					arrows: false,
					pauseOnHover: false,
					speed: 800
				});

				$('.slider-header__next').click(function() {
					slickHeader.slick('slickNext');
				});

				// Go to the previous item
				$('.slider-header__prev').click(function() {
					slickHeader.slick('slickPrev');
				});

				slickHeader.on('beforeChange', function(event) {
					$('.slider-header__next').removeClass('animating');
					setTimeout(function() {
						$('.slider-header__next').addClass('animating');
					}, 1);
				});
			}

			var slickListing = $('.slider-listing .slider__container');

			if (slickListing.length > 0) {
				slickListing.on('init', function(event) {
					$(this).find('.slick-current').addClass('slide--in-place');
				}).slick({
					autoplay: true,
					autoplaySpeed: 5000,
					useTransform: true,
					arrows: false,
					speed: 700,
					cssEase: 'ease-in',
					responsive: [
						{
							breakpoint: 992,
							settings: {
								useTransform: false,
								speed: 400
							}
						}
					]
				});

				$('.slider-listing__next').click(function() {
					slickListing.slick('slickNext');
				});

				// Go to the previous item
				$('.slider-listing__prev').click(function() {
					slickListing.slick('slickPrev');
				});

				slickListing.on('beforeChange', function(event) {
					$(this).find('.slick-current').removeClass('slide--in-place');
				});

				slickListing.on('afterChange', function(event) {
					$(this).find('.slick-current').addClass('slide--in-place');
				});
			}
		};

		return {
			init: init
		};
	})();

	/*
	########   ####  ##     ##  ########   ########    ######    
	##     ##   ##   ##     ##  ##         ##     ##  ##    ##   
	##     ##   ##   ##     ##  ##         ##     ##  ##         
	##     ##   ##   ##     ##  ######     ########    ######    
	##     ##   ##    ##   ##   ##         ##   ##          ##   
	##     ##   ##     ## ##    ##         ##    ##   ##    ##   
	########   ####     ###     ########   ##     ##   ######    
	*/

	$('.scroll-invite').click(function(e) {
		e.preventDefault();
		var page  = $(this).attr('href'); // Page cible
		var speed = 500; // Durée de l'animation (en ms)
		$('html, body').animate( { scrollTop: $(page).offset().top - getMenuHeight() }, speed ); // Go
		return false;
	});

	var mySplitTextElement = $('[data-split-text]');
	if ( mySplitTextElement.length > 0 ) {
		mySplitText = new SplitText(mySplitTextElement.find('span'),{
			type:       'lines',
			linesClass: 'split-line'
		});
	}

	var resize_mcubeSplitText = function() {
		if ( mySplitTextElement.length > 0 ) {
			mySplitText.revert();
			mySplitText = new SplitText(mySplitTextElement.find('span'),{
				type:       'lines',
				linesClass: 'split-line'
			});
		}
	};

	$('.form-container input, .form-container select').focus(function(){
		$(this).closest('p').addClass('current');
	}).blur(function() {
		$(this).closest('p').removeClass('current');
		if( $(this).val() ) {
			$(this).closest('p').addClass('filled');
		} else {
			$(this).closest('p').removeClass('filled');
		}
	});
	
	/*
	 ######       ###     ##         ##         ########   ########   ##    ##   
	##    ##     ## ##    ##         ##         ##         ##     ##   ##  ##    
	##          ##   ##   ##         ##         ##         ##     ##    ####     
	##   ####  ##     ##  ##         ##         ######     ########      ##      
	##    ##   #########  ##         ##         ##         ##   ##       ##      
	##    ##   ##     ##  ##         ##         ##         ##    ##      ##      
	 ######    ##     ##  ########   ########   ########   ##     ##     ##      
	*/
	var zooms = (function() {
		var init = function() {
			$('.zoom-gallery').magnificPopup({
				delegate: 'a',
				type: 'image',
				closeOnContentClick: false,
				closeBtnInside: false,
				mainClass: 'mfp-with-zoom mfp-img-mobile mfp-lagoutte',
				image: {
					verticalFit: true,
				},
				gallery: {
					enabled: true
				}
		      });
		};

		return {
			init: init
		};
	})();

	/*
	##    ##      ###     ##     ##  
	###   ##     ## ##    ##     ##  
	####  ##    ##   ##   ##     ##  
	## ## ##   ##     ##  ##     ##  
	##  ####   #########   ##   ##   
	##   ###   ##     ##    ## ##    
	##    ##   ##     ##     ###     
	*/

	$('.nav-main__open').click(function(e) {
		e.preventDefault();
		$('body').addClass('nav-opened');
	});

	$('.nav-main__close').click(function(e) {
		e.preventDefault();
		$('body').removeClass('nav-opened');
	});

	/*
	####  ##    ##   ####  ########   
	 ##   ###   ##    ##      ##      
	 ##   ####  ##    ##      ##      
	 ##   ## ## ##    ##      ##      
	 ##   ##  ####    ##      ##      
	 ##   ##   ###    ##      ##      
	####  ##    ##   ####     ##      
	*/

	var pageInit = function() {

		// Déclaration des évènements
		$(window).on('resize orientationchange', addEndEvent);
		$(window).on('resizeEnd', resizeHandler);
		$(window).on('scroll', scrollHandler);
		$('body').on('reveal', '.sr', scrollRevealHandler);
		
		$(window).trigger('resize'); // Joue la fonction resizeHandler()
		// initParallax();              // Initialise les effets parallax
		// resizeParallax();
		// initScrollAnimations();      // Initialise les animations de révélations
		formLoader();                // Affiche un 'cache' à la validation d’un form CF7
		detectIOS();                 // Détecte iOS est ajoute une classe au body

		/* Autres scripts qui doivent être initialisés */
		sliders.init();
		zooms.init();

		// Local smooth scroll sur les liens vers des ancres
		if ($('.localscroll').length > 0) {
			$('.localscroll').localScroll( {
				hash: true
			});
			$.localScroll.hash();
		}

		// Fitvids = video embed responsive
		if ($('.fitvids').length > 0) {
			$('.fitvids').fitVids();
		}

		// Transmission des liens vers la fonction linkHandler()
		$('[data-link]').click(function(e) {
			linkHandler( $(this) );
		}).find('a').click(function(e) {
			e.stopPropagation();
		});

		$('a').click(function(e) {
			e.preventDefault();
			linkHandler( $(this) );
		});
	};

	// Initialisation de toutes les fonctions utiles au chargement de la page
	pageInit();
	

	// Exemple d'utilisation du plugin Mcube Gmaps
	if ( $('.map').length > 0 ) {
		$('.map').mcubeGmaps({
			bounds:  false, // default : true
			overlay: false, // default : true
			styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
		});
	}
	

})(jQuery);